// extracted by mini-css-extract-plugin
module.exports = {"news_list__wrapper":"news_news_list__wrapper__uODir","title":"news_title__Iqkh8"};